(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/multi-swiper/assets/javascripts/multi-swiper.js') >= 0) return;  svs.modules.push('/components/components/multi-swiper/assets/javascripts/multi-swiper.js');

var svs = svs || {};

(function(svs) {
  'use strict';

  svs.components = svs.components || {};

  svs.components.MultiSwiper = function(options) {
    options = options || {};
    var scrollers = [];
    var scrollerPositions = [];
    var config = {
      swiperOptions: {
        scrollbars: false,
        scrollingX: false,
        scrollingY: true
      },
      scrollerOptions: []
    };

    for (var prop in options.swiperOptions) {
      if (Object.prototype.hasOwnProperty.call(options.swiperOptions, prop)) {
        config.swiperOptions[prop] = options.swiperOptions[prop];
      }
    }

    if (options.scrollerOptions) {
      config.scrollerOptions = options.scrollerOptions;
    }

    var setupScrollers = function(adjustment) {
      adjustment = adjustment || 0;
      for (var i = 0; i < config.scrollerOptions.length; i++) {
        var node = config.scrollerOptions[i].nodeId;
        var scrollable =
            typeof node === 'string' ? document.getElementById(node) : node;
        var toSubtract = 0;
        for (var j = 0; j < config.scrollerOptions[i].toSubtract.length; j++) {
          var $nodeToSubtract = $(config.scrollerOptions[i].toSubtract[j]);
          var addOffsetPosition = 0;

          if (
            config.scrollerOptions[i].toSubtract[j].indexOf('top-content') !==
            -1
          ) {
            addOffsetPosition = $nodeToSubtract.offset().top;
          }
          toSubtract =
            $nodeToSubtract.length && $nodeToSubtract.is(':visible') ?
              toSubtract + $nodeToSubtract.height() + addOffsetPosition :
              toSubtract;
        }
        $(scrollable).height($(window).height() - toSubtract + adjustment);

        if (config.scrollerOptions[i].noScroller) {
          return false;
        }

        if (typeof scrollers[i] === 'object' && scrollers[i].scroller) {
          scrollers[i].scroller.updateDimensions();
        } else {
          scrollers[i] = new svs.components.Swiper();

          if (config.scrollerOptions[i].onScrollEndCallback) {
            scrollers[i]
              .init(scrollable, config.swiperOptions)
              .addEventListener(
                'reachedend',
                config.scrollerOptions[i].onScrollEndCallback
              );
          } else {
            scrollers[i].init(scrollable, config.swiperOptions);
          }
        }

        if (scrollerPositions[i] && scrollers[i] && scrollers[i].scroller) {
          scrollers[i].scroller.scrollTo(
            scrollerPositions[i].left,
            scrollerPositions[i].top
          );
        }
      }
    };

    var updateSize = function(animationClass, adjustment) {
      animationClass = animationClass || false;
      if (animationClass) {
        $(animationClass).one(
          'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
          function() {
            setupScrollers(adjustment);
          }
        );
      } else {
        setupScrollers(adjustment);
      }
    };

    var addScroller = function(scrollerOptions) {
      if (scrollerOptions) {
        config.scrollerOptions = scrollerOptions;
      }
      setupScrollers();
    };

    var scrollTo = function(ix, left, top, setScrollerPosition) {
      if (setScrollerPosition !== false) {
        scrollerPositions[ix] = { left: left, top: top };
      }

      if (scrollers[ix] && scrollers[ix].scroller) {
        scrollers[ix].scroller.scrollTo(left, top);
      }
    };

    var destroy = function() {
      while (scrollers.length) {
        var scroll = scrollers.pop();
        if (scroll.scroller) {
          scroll.scroller.destroy(false);
          scroll.scroller = null;
        }
        scroll = null;
        $(window).off('resize');
        $(window.document).off('resizeMultiSwiper');
      }
    };

    var resizeIndex;
    $(window).on('resize', function() {
      clearTimeout(resizeIndex);
      resizeIndex = setTimeout(function() {
        setupScrollers();
      }, 300);
    });

    $(window.document).on('resizeMultiSwiper', function() {
      scrollerPositions = [];
      setupScrollers();
    });

    $(window.document).on('multiSwipeRefreshLast', function() {
      if (
        scrollers &&
        scrollers.length &&
        scrollers[scrollers.length - 1].scroller
      ) {
        scrollers[scrollers.length - 1].scroller.refresh();
      }
    });

    return {
      init: function() {
        setupScrollers();
      },
      updateSize: function() {
        updateSize.apply(this, arguments);
      },
      addScroller: function(scrollerOptions) {
        addScroller(scrollerOptions);
      },
      scrollTo: function(ix, left, top, updateScrollerPosition) {
        scrollTo(ix, left, top, updateScrollerPosition);
      },
      destroyAllSwipers: function() {
        destroy();
      },
      getScroller: function(scrollerIndex) {
        scrollerIndex = scrollerIndex || 0;
        return scrollers[scrollerIndex] && scrollers[scrollerIndex].scroller ?
          scrollers[scrollerIndex].scroller :
          null;
      }
    };
  };
})(svs);


 })(window);